module.exports = __webpack_public_path__ + "static/media/work3.52de08af.webp";